import api from '../../axios';
/* eslint-disable */
// 视频点赞
export const apiAddPointup = params => api.post('/vod/addPointup', params);
// 取消点赞
export const apiCancelPointup = params => api.post('/vod/cancelPointup', params);
// 是否点赞
export const apiIsAlreadyPointup = params => api.post('/vod/isAlreadyPointup', params);
// 是否关注了
export const apiIsFollowUser = params => api.post('/user/userFollow/isFollow', params);
// 用户关注
export const apiAddFollow = params => api.post('/user/userFollow/add', params);
// 查询短视频资源位配置信息
export const apiGetResource = params => api.post(`/video/${params.snowId}/resource`);
